export default [
    {
        path: '/aseguradora/index',
        name: 'AseguradoraView',
        component: () => import('../views/aseguradora/aseguradora/AseguradoraView.vue')
    },
    {
        path: '/sucursal-aseguradora/index',
        name: 'SucursaAseguradoralView',
        component: () => import('../views/aseguradora/aseguradora/SucursaAseguradoralView.vue')
    },
    {
        path: '/beneficio/index',
        name: 'BeneficioView',
        component: () => import('../views/beneficio/beneficio/BeneficioView.vue')
    },
    {
        path: '/beneficio-complementario/index',
        name: 'BeneficioComplementarioView',
        component: () => import('../views/beneficio/beneficio/BeneficioComplementarioView.vue')
    },
    {
        path: '/asignacion-beneficio-complementario/index',
        name: 'AsignacionBeneficioComplementarioView',
        component: () => import('../views/beneficio/beneficio/AsignacionBeneficioComplementarioView.vue')
    },
    {
        path: '/proveedor-beneficio/index',
        name: 'ProveedorBeneficioView',
        component: () => import('../views/beneficio/proveedor/ProveedorBeneficioView.vue')
    },
    {
        path: '/proveedor-servicio-complementario/index',
        name: 'ProveedorServicioComplementarioView',
        component: () => import('../views/beneficio/proveedor/ProveedorServicioComplementarioView.vue')
    },
    {
        path: '/condicion-general/index',
        name: 'CondicionGeneralView',
        component: () => import('../views/aseguradora/condicion/CondicionGeneralView.vue')
    },
    {
        path: '/servicio-complementario/index',
        name: 'ServicioComplementarioView',
        component: () => import('../views/beneficio/beneficio/ServicioComplementarioView.vue')
    },
    {
        path: '/formulario-lavado-activo/cliente/index',
        name: 'PLAClienteView',
        component: () => import('../views/aseguradora/prevensionLavadoActivo/PLAClienteView.vue')
    },
    {
        path: '/formulario-lavado-activo/contratante/index',
        name: 'PLAContratanteView',
        component: () => import('../views/aseguradora/prevensionLavadoActivo/PLAContratanteView.vue')
    },
    {
        path: '/inspeccion-vehiculo/index',
        name: 'CargaFotoInspeccionView',
        component: () => import('../views/aseguradora/aseguradora/CargaFotoInspeccionView.vue')
    },
    {
        path: '/consulta-poliza-cliente/index',
        name: 'ConsultaPolizaView',
        component: () => import('../views/aseguradora/consulta/ConsultaPolizaView.vue')
    },
    {
        path: '/consulta-datos-cliente-facturar/index',
        name: 'ConsultaDatosFacturarView',
        component: () => import('../views/aseguradora/consulta/ConsultaDatosFacturarView.vue')
    },
    {
        path: '/consulta-poliza-masivo-cliente/index',
        name: 'ConsultaPolizaClienteView',
        component: () => import('../views/aseguradora/consulta/ConsultaPolizaClienteView.vue')
    },
    {
        path: '/consulta-producto/index',
        name: 'ConsultaProductoView',
        component: () => import('../views/aseguradora/consulta/ConsultaProductoView.vue')
    },
    {
        path: '/servicio-complementario-cliente/index',
        name: 'ServicioComplementarioCliente',
        component: () => import('../views/beneficio/servicio/ServicioComplementarioClienteView.vue')
    }
]